import { combineReducers } from "redux";
import { specsReducer, SpecsState } from "store/features/materialSpecs/specs/specs.reducer";

export type MaterialSpecsState = Readonly<{
    specs: SpecsState;
}>;

export const materialSpecsReducers = combineReducers<MaterialSpecsState>({
    specs: specsReducer,
});
